/*=========================================================================================
  File Name: moduleVisitPointMutations.js
  Description: VisitPoint Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_VISIT_POINT(state, item) {
		state.visitPoints.unshift(item);
	},
	ADD_VISIT_POINT_CHECKED(state, item) {
		const itemIndex = state.checkedVisitPoits.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedVisitPoits.push(item);
		}
	},
	SET_VISIT_POINTS(state, items) {
		state.visitPoints = [...items];
	},
	UPDATE_VISIT_POINT(state, visitPoint) {
		const visitPointIndex = state.visitPoints.findIndex((p) => p.id === visitPoint.id);
		if (visitPointIndex !== -1) {
			Object.assign(state.visitPoints[visitPointIndex], visitPoint);
		}
	},
	REMOVE_VISIT_POINT(state, itemId) {
		const ItemIndex = state.visitPoints.findIndex((p) => p.id === itemId);
		state.visitPoints.splice(ItemIndex, 1);
	},
	UPDATE_PAGINATION(state, dataPagination) {
		Object.assign(state.pagination, dataPagination);
	},
	SELECTED_VISIT_POINT(state, visitPoint) {
		if (visitPoint) {
			state.currentVisitPointId = visitPoint.id !== undefined ? visitPoint.id : 0;
			state.currentVisitPoint = visitPoint;
		} else {
			state.currentVisitPoint = {};
			state.currentVisitPointId = 0;
		}
	}, //selectedVisitPoints
	SET_SELECTED_VISIT_POINTS(state, items) {
		state.selectedVisitPoints = [...items];
	},
	SET_ASSIGNED_VISIT_POINT(state, items) {
		let arrayNew = state.assignedVisitPoints.concat(
			items.filter((element) => state.assignedVisitPoints.find((e) => e.id === element.id) === undefined)
		);
		state.assignedVisitPoints = arrayNew;
	},
	REMOVE_ASSIGNED_VISIT_POINT(state, itemId) {
		const ItemIndex = state.assignedVisitPoints.findIndex((p) => p.id === itemId);
		state.assignedVisitPoints.splice(ItemIndex, 1);
	},
	CLEAR_ASSIGNED_VISIT_POINT(state) {
		state.assignedVisitPoints = [];
	},
	SET_SELECTED_CATEGORY(state, category) {
		state.selectedCategory = category;
	},
	REMOVE_SELECTED_VISIT_POINT(state, itemIds) {
		itemIds.forEach((element) => {
			const ItemIndex = state.visitPoints.findIndex((p) => p.id === element);
			state.visitPoints.splice(ItemIndex, 1);
		});
	},
	DEL_VISIT_POINT_CHECKED(state, item) {
		const itemIndex = state.checkedVisitPoits.findIndex((p) => p.id === item.id);
		if (itemIndex >= 0) {
			state.checkedVisitPoits.splice(itemIndex, 1);
		}
	},
	CLEAR_DEL_VISIT_POINT_CHECKED(state) {
		state.checkedVisitPoits = [];
	},
	SET_VISIT_POINT_CHECKED(state, visitPoints) {
		state.checkedVisitPoits = visitPoints;
	},
};
